import React, { useState } from 'react';
import styles from '@/pages/home/components/styles.scss';
import { history } from 'umi';



export default (props) => {
  const { dataList, courseType } = props;

  if (courseType == '1') {
    return <DrawList dataList={dataList} />;
  } else if (courseType == '2') {
    return <MusicList dataList={dataList} />;
  }else if (courseType == '3') {
    return <FoodList dataList={dataList} />;
  }else{
    return;
  }

}

const DrawList = (props) => {
  const { dataList } = props;
  return (
    <>
      {
        Array.isArray(dataList) ? dataList.map(course => (
          <div className={styles.draw_item} key={course.id} onClick={() => {
            history.push('/home/courseDetail?courseId=' + course.id + '&title=' + course.name);

          }}>
            <img alt='' src={course.image} />
            <div className={styles.title_box}>
              <label className={styles.title_name}>{course.name}</label>
              <label className={styles.title_time}>{course.totalHours}小时{course.totalTime}分钟</label>
            </div>
          </div>
        )) : null
      }
    </>
  )
}



const FoodList = (props) => {
  const { dataList } = props;
  return (
    <div className={styles.h_scroll_box}>
      {
        Array.isArray(dataList) ? dataList.map(course => (
          <div style={{'display': 'inline-block'}} key={course.id} onClick={() => {
            history.push('/home/courseDetail?courseId=' + course.id + '&title=' + course.name);

          }}>
            <div className={styles.scroll_item}>
              <img alt='' src={course.image} />
              <label className={styles.scroll_item_title}>{course.name}</label>
              <label className={styles.scroll_item_subtitle}>{course.intro}</label>
            </div>
          </div>
        )) : null
      }
    </div>
  )
}



const MusicList = (props) => {
  const { dataList } = props;
  return (
    <>
      {
        Array.isArray(dataList) ? dataList.map(course => (
          <div className={styles.music_item} key={course.id} onClick={() => {
            history.push('/home/courseDetail?courseId=' + course.id + '&title=' + course.name);

          }}>
            <img alt='' src={course.image} />
            <div className={styles.music_content}>
              <label className={styles.music_title}>{course.name}</label>
              <label className={styles.music_subtitle}>{course.intro}</label>
            </div>
          </div>
        )) : null
      }
    </>
  )
}


